import PropTypes from 'prop-types';
import { useSubRoutes } from 'hooks';
import { globalPropTypes } from 'helpers';

const Ipma = ({ routes }) => {
  const [renderSubRoutes] = useSubRoutes(routes);

  return renderSubRoutes();
};

Ipma.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
};

Ipma.defaultProps = {
  routes: [],
};

export default Ipma;
